import React from 'react'

function Page404() {
  return (
    <div>Something went wrong</div>
  )
}

export default Page404